<template>
    <div class="float-container" v-if="isDisplay">
        <van-icon name="cross" color="#fff" @click="displaySetting"/>
        <div class="carousel">
            <van-swipe :autoplay="3000" lazy-render :loop="true" :show-indicators="false">
                <van-swipe-item v-for="(item, index) in homeIconList" :key="index">
                    <img :src="item?.icon" alt="" class="carouselItem" @click="goToPath(item?.name)" />
                </van-swipe-item>
            </van-swipe>
        </div>
    </div>
</template>


<script setup lang="ts">
import { useActivityStore } from '@/stores/activity';
import { goToActivityPath } from '@/view/home/supportScript';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from 'vue-router';

const activityStore = useActivityStore()
const homeIconList = computed(() => activityStore.homeFloatActivityList)
const isDisplay = ref(true)
const router = useRouter()
const emits = defineEmits(["openAgentPopup", "openRedEnvelop", "goToHome", "openPWA", 'handleShowTreasurePopup', 'openMisteryBoxPopup'])

const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup', path)
    localStorage.setItem('redirectFromCalim', 'true')
}

const goToPath = (name: any) => {
    goToActivityPath(name, router, handleShowTreasurePopup, emits)
}

const displaySetting = () => {
    isDisplay.value = !isDisplay.value
}

</script>
<style scoped>
.float-container {
    position: fixed;
    bottom: 120px;
    right: 10px;
    z-index: 900;
    width: 20%;
    text-align: right;
}
.carousel{
    text-align: center;
}
.carouselItem{
    width: 100%;
}

</style>